<template>
  <div class="content mb-5">
    <b-row class="mb-6">
      <b-col cols="12">{{
        $t(
          "If you are installing WebTitan OTG 2 for Chromebooks, use the .PEM format certificate to import into Google Workspace."
        )
      }}</b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-3">
        <b-card>
          <b-col>
            <h3>{{ $t("SSL Certificate") }}</h3>
          </b-col>

          <b-col cols="12" class="mt-4">
            <b-button
              data-test-id="ssl-certificate-download-certificate"
              variant="secondary"
              :href="sslCertLink"
              >{{ $t("Download") }}</b-button
            >
            <!--            <b-button-->
            <!--                data-test-id="ssl-certificate-download-certificate"-->
            <!--                variant="secondary"-->
            <!--                @click="downloadCert('der')"-->
            <!--            >{{ $t("Download") }}</b-button-->
            <!--            >-->
          </b-col></b-card
        >
      </b-col>
      <b-col cols="6">
        <b-card>
          <b-col>
            <h3>{{ $t("PEM Certificate") }}</h3>
          </b-col>
          <b-col cols="12" class="mt-4">
            <b-button
              data-test-id="ssl-certificate-download-certificate"
              variant="secondary"
              :href="pemCertLink"
              >{{ $t("Download") }}</b-button
            >
            <!--            <b-button-->
            <!--              data-test-id="ssl-certificate-download-certificate"-->
            <!--              variant="secondary"-->
            <!--              @click="downloadCert('pem')"-->
            <!--              >{{ $t("Download") }}</b-button-->
            <!--            >-->
          </b-col></b-card
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      fetching: false,
      form: {
        sslCert: null,
      },
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("support", ["downloadCertificate"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async onSubmit() {
      this.fetching = true;
      try {
        this.displayToast({
          title: this.$t("Error"),
          message: "Missing endpoint",
          duration: 2000,
          variant: "danger",
        });
      } finally {
        this.fetching = false;
      }
    },
  },
  validations: {
    form: {
      sslCert: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
    pemCertLink() {
      return `${process.env.VUE_APP_API_URL}/ssl/ca.pem`;
    },
    sslCertLink() {
      return `${process.env.VUE_APP_API_URL}/ssl/ca.der`;
    },
  },
  created() {
    this.setPageTitle(this.$t("Certificates"));
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "When WebTitan Cloud intercepts an SSL connection, it presents a fake server certificate to the client browser. The client browser will issues a security warning to the end-user because the browser does not trust the issuer used by WebTitan. This warning does not occur if the issuer root certificate used by WebTitan Cloud is imported as a trusted root certificate in the client browser's certificate store."
      ),
    ]);
  },
};
</script>
